export default __webpack_public_path__ + "static/media/video.a74d3691.png";